import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'

export default combineReducers({
  byId: createByIdReducer('offer'),
  allIds: createAllIdsReducer('offer'),
  indexIds: createIndexIdsReducer('offer'),
  meta: createMetaReducer('offer'),
})

//Selectors

export const selectOfferIndex = (state) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectOfferMeta = (state) => {
  return state.meta || {}
}

export const selectOffer = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}
